import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styled from "@emotion/styled";
import ETH from "../../../../../assets/Images/eth.png";
// import SHIA from "../../../../assets/Images/shia.png";
import USDT from "../../../../../assets/Images/usdt.png";
import USDC from "../../../../../assets/Images/usdc.png";
import DAI from "../../../../../assets/Images/dai.png";
import { Image } from "../../../../Styles/style";
import Paragraph from "../../../MainComponent/Paragraph";
import CustomButton from "../../../MainComponent/CustomBtn";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { BorrowPageContext } from "..";

const RowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  column-gap: 5px;
`;
const CoulmnDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;
const TContainer = styled(TableContainer)`
  background-color: transparent !important;
  font-family: PoppinsB !important;
  color: #707070 !important;
  box-shadow: none;
`;
const TCell = styled(TableCell)`
  font-family: PoppinsB !important;
  color: #707070 !important;
  text-align: left;
  padding: 5px;
`;
function createData(Assets, Available, Fee, MarketSize) {
  return { Assets, Available, Fee, MarketSize };
}

export default function BorrowPageTable() {
  const {pageState, setPageState} = React.useContext(BorrowPageContext)
  console.log(pageState)
  const rows = [
    createData(
      <RowDiv>
        <Image mw="20px" src={ETH} />
        <Paragraph fs="14px" p="0" ta="left">
          ETH
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          $0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        1.5%
      </Paragraph>,
      <CoulmnDiv>
      <Paragraph fs="14px" p="0" ta="left">
        0
      </Paragraph>
      <Paragraph fs="12px" color="#707070" p="0" ta="left">
        $0
      </Paragraph>
    </CoulmnDiv>,
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={USDT} />
        <Paragraph fs="14px" p="0" ta="left">
          USDT
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        0.7%
      </Paragraph>,
      <CoulmnDiv>
      <Paragraph fs="14px" p="0" ta="left">
        0
      </Paragraph>
      <Paragraph fs="12px" color="#707070" p="0" ta="left">
        $0
      </Paragraph>
    </CoulmnDiv>,
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={USDC} />
        <Paragraph fs="14px" p="0" ta="left">
          USDC
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        1.5%
      </Paragraph>,
      <CoulmnDiv>
      <Paragraph fs="14px" p="0" ta="left">
        0
      </Paragraph>
      <Paragraph fs="12px" color="#707070" p="0" ta="left">
        $0
      </Paragraph>
    </CoulmnDiv>,
    ),
    createData(
      <RowDiv>
        <Image mw="20px" src={DAI} />
        <Paragraph fs="14px" p="0" ta="left">
          DAI
        </Paragraph>
      </RowDiv>,
      <CoulmnDiv>
        <Paragraph fs="14px" p="0" ta="left">
          0
        </Paragraph>
        <Paragraph fs="12px" color="#707070" p="0" ta="left">
          %0
        </Paragraph>
      </CoulmnDiv>,
      <Paragraph fs="14px" p="0" ta="left">
        1.5%
      </Paragraph>,
      <CoulmnDiv>
      <Paragraph fs="14px" p="0" ta="left">
        0
      </Paragraph>
      <Paragraph fs="12px" color="#707070" p="0" ta="left">
        $0
      </Paragraph>
    </CoulmnDiv>,
    ),
  ];
  return (
    <TContainer component={Paper}>
      <Table sx={{ minWidth: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TCell>Assets</TCell>
            <TCell align="right">
              <RowDiv>
                Available
                <Tooltip
                  title="This is the total amount available for 
                  you to borrow. You can borrow 
                  based on your collateral and until 
                  the borrow cap is reached."
                  placement="top"
                >
                  <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
                </Tooltip>
              </RowDiv>
            </TCell>
            <TCell align="right">
              <RowDiv>
                Fee
                <Tooltip
                  title="Fixed fee charged on 
                  borrowed asset."
                  placement="top"
                >
                  <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
                </Tooltip>
              </RowDiv>
            </TCell>
            <TCell align="right">Market Size</TCell>
            <TCell align="right">&nbsp;</TCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.Assets}
              </TableCell>
              <TableCell align="right">{row.Available}</TableCell>
              <TableCell align="right">{row.Fee}</TableCell>
              <TableCell align="right">{row.MarketSize}</TableCell>
              <TableCell align="right">
                <CustomButton
                 onClick={()=>{setPageState("1st")}}
                  w="90px"
                  p="4px 10px"
                  b="1px solid #FE9C02"
                  c="#FE9C02"
                  bgc="transparent"
                  hbgc="transparent"
                  hc="#FE9C02"
                >
                  Borrow
                </CustomButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TContainer>
  );
}
